var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("이용약관 준비중입니다.")])}
var staticRenderFns = []

export { render, staticRenderFns }